import { useEventRefresher as s } from "@zdrbm/zdr-react";
import m, { useMemo as p, useEffect as h } from "react";
import { MultiSelectDropdownMenuState as g } from "./index.es5613.js";
import { highlightTextWithinItems as l } from "./index.es549.js";
function D({
  state: i,
  searchTerm: e,
  autoFocus: r,
  items: o,
  onItemClick: f,
  onItemsFiltered: u
}) {
  const t = p(() => i ?? new g(
    l({
      searchTerm: e,
      items: o,
      shouldFilter: !0,
      onItemsFiltered: u
    }),
    r
  ), [i]);
  return s(t.highlightedItems), h(() => {
    t.setAutofocus(r);
  }, [t, r]), h(() => t.onItemAction.reo((n) => {
    f({ ...n, multiselectState: t });
  }), [t, f]), m.useEffect(() => {
    const n = l({
      searchTerm: e,
      items: o,
      shouldFilter: !0,
      onItemsFiltered: u
    });
    t.setItems(n);
  }, [u, t, o, e]), t;
}
export {
  D as useDropDownMenu
};
//# sourceMappingURL=index.es2488.js.map
